import actionTypes from '../actionTypes';

export function updateLevelRequest({ level }) {
  return {
    type: actionTypes.UPDATE_LEVEL_REQUEST,
    level
  };
}

export function updateLevelSuccess() {
  return {
    type: actionTypes.UPDATE_LEVEL_SUCCESS
  };
}
